import React from 'react';
import PropTypes, { object } from 'prop-types';

import { Heading } from 'components/common/Elements/Elements';
import DonutNewT from 'components/common/charts/DonutNewT/DonutNewT';
import Bars from './Bars/Bars';

import { round2 } from 'utils/common';

import classes from './DimensionsChart.module.scss';

const DIMENSIONS_COLORS = {
  Deployment: '#CB5BCB',
  Usage: '#4DC9F6',
  Satisfaction: '#F1CA3A',
  Relationship: '#67B4AE'
};

const DimensionsChart = ({ chartData, additional }) => {
  const empty = arr => {
    return arr.reduce((accumulator, currentValue) => {
      currentValue.color = DIMENSIONS_COLORS[currentValue.name];
      return accumulator + currentValue.score;
    }, 0);
  };

  const dimension = round2(empty(chartData));

  const donutData = [
    ...chartData,
    {
      name: 'Empty',
      weight: 0,
      score: round2(100 - dimension),
      tooltip: [],
      color: '#dde6f2'
    }
  ];

  return (
    <section className={classes.box}>
      <Heading className={classes.header}>Dimensions</Heading>
      <DonutNewT data={donutData} centerText={additional} />
      <Bars data={chartData} />
    </section>
  );
};

DimensionsChart.propTypes = {
  chartData: PropTypes.oneOfType([PropTypes.arrayOf(object), PropTypes.bool]),
  additional: PropTypes.number
};

export default DimensionsChart;
